import { Helmet } from 'react-helmet-async'
import PageLayout from '../components/layout/PageLayout.jsx'
import SectionHeading from '../components/ui/SectionHeading.jsx'
import PharmaCard from '../components/ui/PharmaCard.jsx'
import { services } from '../data/services.js'
import { motion } from 'framer-motion'

export default function Services() {
  return (
    <PageLayout>
      <Helmet>
        <title>Services | Ritik Medicare Pvt. Ltd.</title>
        <meta
          name="description"
          content="Explore Ritik Medicare services: API development, process development, custom synthesis, contract manufacturing, regulatory support and technical consultancy."
        />
      </Helmet>

      <section className="bg-sectionBg">
        <div className="mx-auto max-w-7xl px-4 py-12 sm:py-16">
          <SectionHeading
            eyebrow="Pharmaceutical Services"
            title="Everything you need for quality-first API manufacturing"
            subtitle="Our team delivers end-to-end support—from development to production readiness." 
          />

          <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {services.map((s) => (
              <PharmaCard key={s.title} title={s.title} desc={s.desc} className="bg-white/80" />
            ))}
          </div>

          <motion.div
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="mt-10 rounded-3xl border border-slate-200 bg-white p-7"
          >
            <div className="font-extrabold text-slate-900">Need a tailored solution?</div>
            <p className="mt-2 text-sm sm:text-[16px] text-slate-600 leading-relaxed">
              Share your molecule, target specs and timeline. We’ll guide feasibility and next steps based on quality constraints and manufacturing requirements.
            </p>
            <div className="mt-5 flex flex-col sm:flex-row gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center rounded-2xl bg-brand-primary text-white px-5 py-3 font-semibold hover:brightness-110 transition"
              >
                Enquire Now
              </a>
              <a
                href="/products"
                className="inline-flex items-center justify-center rounded-2xl border border-slate-200 bg-white px-5 py-3 font-semibold text-slate-900 hover:bg-slate-50 transition"
              >
                View Products
              </a>
            </div>
          </motion.div>
        </div>
      </section>
    </PageLayout>
  )
}

